import moment from 'moment-timezone';

export function formatDate(
  date: string,
  format: string,
  timezone: string
): string {
  return moment.tz(date, timezone).format(format);
}

export function formatExactDate(date: string, format: string): string {
  return moment(date).format(format);
}

export function formatFilterDate(date: Date, timezone: string): string {
  const newDate = moment.tz(moment(date).format('YYYY-MM-DD'), timezone);
  return newDate.toISOString();
}

export const formatUTCDateString = (
  isoDate: string,
  format: string
): string => {
  return moment(new Date(isoDate)).utc().format(format);
};

export const upperFirstChar = (text: string): string => {
  return `${text[0].toUpperCase()}${text.substring(1, text.length)}`;
};

export const getStringAbbreviation = (value: string): string => {
  const reg = /^([a-zA-Z])|\s([a-zA-Z])/g;
  const abbreviation = value.match(reg);
  let stringAbbreviation: string = '';

  if (abbreviation) {
    stringAbbreviation = abbreviation[0].replace(/\s+/g, '');

    if (abbreviation.length >= 2) {
      stringAbbreviation += abbreviation[1].replace(/\s+/g, '');
    }

    if (abbreviation.length >= 3) {
      stringAbbreviation += abbreviation[2].replace(/\s+/g, '');
    }
  }

  return stringAbbreviation;
};

export function replaceSpecialChars(value: string, char: string): string {
  return value.replace(/[^a-zA-Z0-9_-]/g, char);
}

const VALID_NAME_SUBSTRINGS = ['jr', 'jr.'];

function isValidNameSubstring(value: string): boolean {
  return VALID_NAME_SUBSTRINGS.includes(value.toLowerCase());
}
function isRomanNumber(value: string): boolean {
  return /^M{0,3}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/.test(value);
}

export function formatName(value: string): string {
  let result = '';
  const words = value.trim().split(' ');
  const lastWord = words[words.length - 1];
  const lastWordIndex: number =
    isValidNameSubstring(lastWord) || isRomanNumber(lastWord)
      ? words.length - 2
      : words.length - 1;

  words.forEach((w, index) => {
    if (
      isValidNameSubstring(w) ||
      isRomanNumber(w) ||
      index === lastWordIndex
    ) {
      result += `${w} `;
    } else {
      result += `${w[0]}. `;
    }
  });

  return result.trim();
}

export function formatSeconds(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}
